import { styled } from 'styled-components';

export const EmbeddedVideo = styled.div`
  height: 449px;

  iframe {
    height: 100%;
    width: 100%;
  }
`;
EmbeddedVideo.displayName = 'EmbeddedVideo';

export const BasicTableWrapper = styled.div`
  table {
    padding: ${({ theme }) =>
      `${theme.sizing.xxtiny} 0 ${theme.sizing.xtiny} 0`};
  }
`;
BasicTableWrapper.displayName = 'BasicTableWrapper';

export const StatsBlock = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.small};
  font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
  padding: ${({ theme }) => theme.sizing.medium};
  min-height: 7.3125rem;
  flex-direction: column;

  @media (min-width: 1440px) {
    flex-direction: row;
  }
  @media (max-width: 1028px) {
    flex-direction: row;
  }

  a {
    color: ${({ theme }) => theme.colours.ink.primary.main};
    text-decoration: underline;
  }

  a:hover {
    color: ${({ theme }) => theme.colours.interface.strong};
  }
`;

export const StatsBlockLeftColumn = styled.div`
  display: flex;
  gap: 3.2rem;
  flex-direction: row;
`;

export const StatsBlockRightColumn = styled.div`
  @media (min-width: 1440px) {
    border-left: ${({ theme }) =>
      `1px solid ${theme.colours.canvas.primary.main}`};
    padding-left: ${({ theme }) => theme.sizing.medium};
    margin-left: ${({ theme }) => theme.sizing.medium};
  }
  @media (max-width: 1028px) {
    border-left: ${({ theme }) =>
      `1px solid ${theme.colours.canvas.primary.main}`};
    padding-left: ${({ theme }) => theme.sizing.medium};
    margin-left: ${({ theme }) => theme.sizing.medium};
  }
  border-left: ${({ theme }) =>
    `1px solid ${theme.colours.canvas.primary.main}`};
  padding-left: ${({ theme }) => theme.sizing.medium};
  margin-left: ${({ theme }) => theme.sizing.medium};
`;

export const StatsBlockItemHeader = styled.div`
  color: ${({ theme }) =>
    theme.applyOpacity(theme.colours.ink.primary.main, 'secondary')};
  font-size: ${({ theme }) => theme.typography.bodySmall.fontSize};
  padding-bottom: ${({ theme }) => theme.sizing.small};
`;

export const StatsBlockItem = styled.div`
  color: ${({ theme }) =>
    theme.applyOpacity(theme.colours.ink.primary.main, 'secondary')};
  font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
`;

export const OutcomeRoundel = styled.div`
  position: relative;
  padding-left: ${({ theme }) => theme.sizing.medium};

  &::before {
    position: absolute;
    left: 0;
    top: 4px;
    content: '';
    border: ${({ theme, $color }) =>
      `${$color ? '5px' : '0px'} solid ${
        $color || theme.colours.ink.primary.main
      }`};
    border-radius: 50%;
  }
`;

export const StatsPlayersWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.medium};
  width: max-content;
`;

export const VideoTileSubtitleWrapper = styled.div`
  padding-top: ${({ theme }) => theme.sizing.tiny};
`;
VideoTileSubtitleWrapper.displayName = 'VideoTileSubtitleWrapper';
